import React from "react";
import Typography from "@material-ui/core/Typography";
const InventoryReports = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Inventory Reports
      </Typography>
      <Typography paragraph variant="h5">
        Explore dashboard and various reports of Inventory module
      </Typography>
      <Typography paragraph variant="body1">
        Inventory Reports is one of the features under the Inventory module to
        display various reports regarding the Inventory business process. It is
        used to analyze information, determine conclusions, and offer
        recommendations to solve problems.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the tabs indicating
        the various report types. The various reports under the Inventory module
        are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Inventory Dashboard</b>
        <br />
        This is the main dashboard of the Inventory module. There is a lot of
        high-level information shown as a widget to give you the best insight
        regarding what happens in the Inventory business process. This best
        analytic information will help you a lot to make business decisions.
        Below are the available widgets inside this dashboard:
        <ul>
          <li>Fill Rate Widget</li>
          <li>Backorder Rate Widget</li>
          <li>Return Rate Widget</li>
          <li>Accuracy Rate Widget</li>
          <li>Safe Stock Rate Widget</li>
          <li>Turnover Ratio Widget</li>
          <li>Stock Current Value Widget</li>
          <li>Products Widget</li>
          <li>Average Fulfillment Time Widget</li>
          <li>Average Days To Sell Widget</li>
          <li>Stock Value Widget</li>
          <li>Order Fulfillment Widget</li>
          <li>Stock Quantity Widget</li>
          <li>Inventory Status Widget</li>
          <li>Top 5 Stock Value Widget</li>
          <li>Top 5 Stock Reorder Widget</li>
          <li>Top 5 Stock Quantity Widget</li>
          <li>Inventory Turnover Widget</li>
          <li>Stock Opname Widget</li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Stock Availability</b>
        <br />
        This report tells you about the available on-hand and in-transit stock
        in each warehouse or outlet with reorder estimation analysis based on
        the stock safety threshold.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Stock Value</b>
        <br />
        This report tells you about the all-stock estimation value in each
        warehouse or outlet with average days to sell and inventory turnover
        analysis.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Stock Movement</b>
        <br />
        This report tells you about every movement of stock in each warehouse or
        outlet including the item movement quantity information from and to any
        location.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Stock Opname</b>
        <br />
        This report tells you about the stock counting activity in each
        warehouse or outlet including the reason information of surplus or
        deficit stock after stock calculation.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Stock Aging</b>
        <br />
        This report tells you about the aging of the stock in each warehouse or
        outlet including the information of how long the stock is staying in the
        location and the expiration status of every stock.
      </Typography>
    </React.Fragment>
  );
};

export default InventoryReports;
